import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Gotemplate extends Component {
 
  render() {
    const course =[
      {
        title : "Introduction to Go",
        content: [
        "Introduction and background of Go",
        "Installing and setting up Go",
        "Basic concepts of Go programming",
        "Writing and running your first Go program",
        "Understanding Go syntax"
        ]
        },
        {
        title : "Variables and Data Types in Go",
        content: [
        "Variables and constants",
        "Primitive data types",
        "Composite data types",
        "Type conversion and casting",
        "Working with strings"
        ]
        },
        {
        title : "Control Structures in Go",
        content: [
        "If-else statements",
        "Switch statements",
        "Loops in Go",
        "Breaking and continuing loops",
        "Working with arrays and slices"
        ]
        },
        {
        title : "Functions in Go",
        content: [
        "Defining functions",
        "Passing arguments to functions",
        "Returning values from functions",
        "Anonymous functions",
        "Function closures"
        ]
        },
        {
        title : "Pointers and Memory Management in Go",
        content: [
        "Pointers in Go",
        "Using pointers for memory management",
        "Garbage collection in Go",
        "Allocating and deallocating memory",
        "Working with structures in Go"
        ]
        },
        {
        title : "Concurrency in Go",
        content: [
        "Goroutines and threads",
        "Using channels for communication",
        "Using locks and mutexes for synchronization",
        "Working with select statements",
        "Creating and using custom data types"
        ]
        },
        {
        title : "Packages and Libraries in Go",
        content: [
        "Creating and using packages",
        "Importing and exporting functions and variables",
        "Using third-party libraries",
        "Documenting code with GoDoc",
        "Testing and debugging in Go"
        ]
        },
        {
        title : "Web Development in Go",
        content: [
        "Building web applications with Go",
        "Working with HTTP requests and responses",
        "Using templates and static files",
        "Creating and using APIs",
        "Deploying Go applications"
        ]
        },
        {
        title : "Advanced Topics in Go",
        content: [
        "Error handling in Go",
        "Reflection and type introspection",
        "Using the standard library",
        "Using interfaces and polymorphism",
        "Creating and using custom data structures"
        ]
        },
        {
        title : "Design Patterns in Go",
        content: [
        "Introduction to design patterns",
        "Using the Singleton pattern in Go",
        "Using the Factory pattern in Go",
        "Using the Strategy pattern in Go",
        "Using the Decorator pattern in Go"
        ]
        },
        {
        title : "Developing with Go Tools",
        content: [
        "Using the Go command line tool",
        "Working with the Go workspace",
        "Using the Go debugger",
        "Using profiling and benchmarking tools",
        "Using code analysis tools"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Go programming language? ',
        answer:
          'Go is an open-source, statically typed, and compiled programming language developed by Google. It is designed to be simple, efficient, and capable of handling concurrent programming challenges, making it an excellent choice for building scalable and high-performance applications. ',
      },
      {
        question: 'Is Go suitable for beginners or experienced programmers? ',
        answer:
          'Our Go course is designed to cater to both beginners and experienced programmers. While prior programming experience can be beneficial, we cover the fundamentals of Go programming, making it accessible to those new to the language.',
      },
      {
        question: 'How does Go compare to other programming languages like Python and Java?',
        answer:
          'While each language has its strengths and weaknesses, Go is often preferred for its fast execution times, built-in concurrency support, and ease of use, particularly for developing network and web applications.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Go skills can pursue a variety of career opportunities such as Software Developer, Back-End Developer, Cloud Engineer, DevOps Engineer, and Site Reliability Engineer (SRE).'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To join our Go training, you should know basic programming concepts like variables, loops, conditions, and functions. Go emphasizes simple and efficient code, so you need strong problem-solving skills and logical thinking abilities to write clean, maintainable programs. Go is a flexible language used for many applications, so you must be eager to explore what it can do and learn about its newest updates. Our Go course requires hard work and dedication throughout the entire program duration. "
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Go is an open source programming language used for general purpose.It is useful for carrying out programming for scalable servers and large software systems. The Golang programming language was built to fill in the gaps of C++ and Java that Google came across while working with its servers and distributed systems"/>
          */}
           <NewMainsec rating='4.2' students={"205"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Go is an open source programming language used for general purpose.It is useful for carrying out programming for scalable servers and large software systems. The Golang programming language was built to fill in the gaps of C++ and Java that Google came across while working with its servers and distributed systems"/>
          
          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Go Language ${this.props.location1} is a highly sought-after skill, as the demand for Go Language professionals continues to rise. At Learnsoft.org, we offer comprehensive Go Language training courses in ${this.props.location} to help individuals enhance their skills and gain a deep understanding of the Go programming language. Our experienced trainers use a hands-on approach, incorporating real-world examples and practical exercises, to provide a well-rounded education. Whether you are new to Go or looking to upgrade your skills, Learnsoft.org's Go Language ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our Go Language courses and start your journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Go Language course covers a wide range of topics, including Go syntax, Go programming paradigms, concurrency, and Go libraries. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Go programming. By the end of the course, you will be able to write efficient and scalable Go code for various applications."} />
		</section>

 <Batchtime title={this.props.title} fees="25,999" offer="15,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>   
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou='Python' coupath='python' cou10='Full Stack Developer' coupath10='full-stack-developer' cou6='AngularJS' coupath6='angularjs' cou9='Front End Developer' coupath9='front-end-developer'
          cou5='ReactJS' coupath5='reactjs' cou3='JavaScript' coupath3='javascript' cou7='GoCD' coupath7='gocd'
          cou1='DevOps' coupath1='devops' cou8='Flutter' coupath8='flutter'  cou4='R Programming' coupath4='rprogram' />

      </>
    );
  }
}
